import React from 'react';
import {greyishBlue50} from "../../../../assets/jss/main";

function ZoneContainer(props) {
    return (
        <div
            style={{
                padding: '16px',
                display: 'flex',
                gap: '8px',
                borderBottom: `1px solid ${greyishBlue50}`,
                borderTop: `1px solid ${greyishBlue50}`,
                overflowX: 'auto',
            }}
        >
            {props.children}
        </div>
    );
}

export default ZoneContainer;
